import React from 'react'
import { ShadowBox } from 'app/caterers'

export default function CatererList(props) {
  const { caterers } = props

  return (
    <div className="container mt-8 mb-10">
      {caterers && (
        <div className="md:mt-6 md:mb-6 lg:mt-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {caterers.map(caterer => (
              <ShadowBox
                key={caterer.id}
                caterer={caterer}
                photo={caterer.photo}
                city={caterer.cities[0]}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
